import {Link} from 'react-router-dom';
import React, { useState, useEffect, useContext } from 'react';
import {WebContext} from '../webcontext';

import { FaFacebook, FaMixcloud, FaTwitch } from "react-icons/fa6";

export default function Footer() {
  const service = useContext(WebContext);

  switch(service.web?.service.template) {
    case 2:
      return(
        <footer className="site-footer">
          <div className="footer-content">
            <div className="footer-brand">
              <p className="footer-tagline">The Best DJs. The Best Music. 24/7</p>
              <p className="footer-desc">Created by DJs, for DJs. House music community from around the world.</p>
            </div>
            <div className="footer-links">
              <p className="footer-tagline">Explore</p>
              <Link to="/listen" data-nav="">Listen</Link>
              <Link to="/chat" data-nav="">Chat</Link>
              <Link to="/schedule" data-nav="">Schedule</Link>
              <Link to="/mixes" data-nav="">Mixes</Link>
            </div>
            <div className="footer-links">
              <p className="footer-tagline">Our DJ's</p>
              <Link to="/ourdjs" data-nav="">Our DJ's</Link>
              <Link to="/joinus" data-nav="">Join Us</Link>
              <Link to="/privacy" data-nav="">Privacy Policy</Link>
              <Link to="/terms" data-nav="">Terms &amp; Conditions</Link>
            </div>
            <div className="footer-social">
              <p className="footer-tagline">Follow us on our socials</p>
              {Object.keys(service.web?.service).filter(elem => elem.indexOf('s_') === 0 && elem !== 's_website').map((e, i) => {
                switch(e) {
                  case 's_facebook':
                    return (
                      <a href={service.web.service[e]} target="_blank" rel="noreferrer" className="d-center socialbg border-0 radius100">
                        <i class="fab fa-facebook-f"></i>
                      </a>
                    )
                  case 's_mixcloud':
                    return (
                      <a href={service.web.service[e]} target="_blank" rel="noreferrer" className="d-center socialbg border-0 radius100">
                        <i class="fab fa-mixcloud"></i>
                      </a>
                    );
                  case 's_twitch':
                    return (
                      <a href={service.web.service[e]} target="_blank" rel="noreferrer" className="d-center socialbg border-0 radius100">
                        <i class="fab fa-twitch"></i>
                      </a>
                      );
                  default:
                    return (<>something</>);
                }
              })}
            </div>
          </div>
          <div className="footer-bottom">
            © Copyright 2026 <Link to={'/'} className="pra-clr primaryhover cmn-hover">{service.web.service.title}</Link>
          </div>
        </footer>
      )
    case 1:
      return (
        <footer className="footer-version-one heading-bg zindex1 position-relative">
          <div className="container">
            <div className="footer-topversion-one pt-20 pb-20">
              <div className="row gy-lg-0 gy-10 mt-xxl-5 mb-xxl-5 justify-content-sm-between justify-content-center">
                <div className="col-lg-3 col-md-6 col-sm-6">
                  <div className="footer-widget">
                    <p className="white-clr fs20 body-font mb-xxl-7 mb-6 aos-init" data-aos="zoom-in" data-aos-duration="1600">
                      A rotating timetable featuring House, Techno, Bass, Trance, Drum & Bass, and more. Special events: live DJ takeovers and guest mixes.
                    </p>
                    <ul className="common-social d-flex align-items-center gap-2">
                      {Object.keys(service.web?.service).filter(elem => elem.indexOf('s_') === 0 && elem !== 's_website').map((e, i) => {
                        switch(e) {
                          case 's_facebook':
                            return (
                              <li key={i} data-aos="zoom-in-right" data-aos-duration="1400" className="aos-init">
                                <a href={service.web.service[e]} target="_blank" rel="noreferrer" className="d-center socialbg border-0 radius100">
                                  <FaFacebook />
                                </a>
                              </li>
                            )
                          case 's_mixcloud':
                            return (
                              <li key={i} data-aos="zoom-in-right" data-aos-duration="1400" className="aos-init">
                                <a href={service.web.service[e]} target="_blank" rel="noreferrer" className="d-center socialbg border-0 radius100">
                                  <FaMixcloud />
                                </a>
                              </li>
                            );
                          case 's_twitch':
                          return (
                              <li key={i} data-aos="zoom-in-right" data-aos-duration="1400" className="aos-init">
                                <a href={service.web.service[e]} target="_blank" rel="noreferrer" className="d-center socialbg border-0 radius100">
                                  <FaTwitch />
                                </a>
                              </li>
                            );
                          default:
                            return null;
                        }
                      })}
                    </ul>
                  </div>
                </div>
                <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-6 col-sm-6">
                  <div className="footer-widget">
                    <div className="footer-title d-flex align-items-center fs20 fw-700 body-font gap-2 mb-xxl-8 mb-xl-6 mb-5 aos-init" data-aos="zoom-in-down" data-aos-duration="1900">
                      Explore
                      <img src="/images/line.webp" alt="img" />
                    </div>
                    <ul className="link-footer d-grid gap-xxl-3 gap-3 aos-init" data-aos="zoom-in" data-aos-duration="1400">
                      <li>
                        <Link to={'/about'} className="d-flex align-items-center gap-2 flink-items pra-clr">
                          About
                        </Link>
                      </li>
                      <li>
                        <Link to={'/schedule'} className="d-flex align-items-center gap-2 flink-items pra-clr">
                          Schedule
                        </Link>
                      </li>
                      <li>
                        <Link to={'/mixes'} className="d-flex align-items-center gap-2 flink-items pra-clr">
                          Mixes
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-6 col-sm-6">
                  <div className="footer-widget">
                    <div className="footer-title d-flex align-items-center fs20 fw-700 body-font gap-2 mb-xxl-8 mb-xl-6 mb-5 aos-init" data-aos="zoom-in-down" data-aos-duration="1900">
                      Our DJ's
                      <img src="/images/line.webp" alt="img" />
                    </div>
                    <ul className="link-footer d-grid gap-xxl-3 gap-3 aos-init" data-aos="zoom-in" data-aos-duration="1400">
                      <li>
                        <Link to={'/ourdjs'} className="d-flex align-items-center gap-2 flink-items pra-clr">
                          OurDJs
                        </Link>
                      </li>
                      <li>
                        <Link to={'/joinus'} className="d-flex align-items-center gap-2 flink-items pra-clr">
                          Join Us
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-6 col-sm-6">
                  <div className="footer-widget">
                    <div className="footer-title d-flex align-items-center fs20 fw-700 body-font gap-2 mb-xxl-8 mb-xl-6 mb-5 aos-init" data-aos="zoom-in-down" data-aos-duration="1900">
                      Contact
                      <img src="/images/line.webp" alt="img" />
                    </div>
                    <div className="widget-call d-grid gap-xxl-4 gap-3">
                      <div className="d-flex align-items-center gap-xxl-4 gap-3">
                        <i className="fas fa-clock pra-clr"></i>
                        <span className="pra-clr">
                          Mon - Sun: 8AM - 8PM
                        </span>
                      </div>
                      <div className="d-flex align-items-center gap-xxl-4 gap-3">
                        <i className="fas fa-envelope pra-clr"></i>
                        <a href="mailto:contact@dnaradio.uk" className="cmn-hover pra-clr">
                          contact@dnaradio.uk
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="footer-bottom-version-one heading-bg overflow-hidden cmn-bordert text-center px-xxl-7 px-6 py-xxl-6 py-xl-6 py-3">
            <p className="pra-clr">
              © Copyright 2026 <Link to={'/'} className="pra-clr primaryhover cmn-hover">{service.web.service.title}</Link>
            </p>
          </div>

          <img src="/images/footer-element.webp" alt="img" className="footer-sound-element" />
        </footer>
      )
    default:
      return (<></>)
  }
}
